import React, { useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"
import moment from 'moment';

const TablaMultaVehiculos = props => {

    let op = require('../../../../src/modulos/datos');

    const headCells = [
        { id: 'fechamulta', label: 'FECHA', width: '80px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'descripcion', label: 'DESCRIPCIÓN', width: '200px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'idcontribuyente', label: 'CODIGO CONTRIBUYENTE', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'valor', label: 'MULTA', width: '100px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
        { id: 'cancelada', label: 'ESTATUS', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white", disableSorting: true },
    ]

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    useEffect(() => {

        if (props.tabmulta) {
            setRecords(props.tabmulta);
        }

    }, [props.tabmulta]);

    const imprimirDeuda = (reporte) => (event) => {
        event.preventDefault();

        var idcomercio = props.idcomercio;
        reporte = 'HisPago_IndCom';
        //window.open(op.reportes + "reporte=" + reporte + "&id=" + idcomercio, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte + "&id=" + idcomercio, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="content" >
                    <div className="container">
                   {/*      <div align="center" className="col-md-2 ml-auto">
                            <button style={{ marginBottom: "5px" }} className="btn btn-primary btn-sm rounded-circle"><i className="fas fa-print"></i> </button>
                        </div> */}
                        <div className="row">

                            <div className="col-md-12" style={{ margin: "auto" }} >
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.fechamulta} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechamulta).format('DD-MM-YYYY')}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.descripcion}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idcontribuyente}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.valor.toString().replace('.', ','), ',', '.', 2)}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.cancelada === true ? 'PAGADA' : 'POR PAGAR'}</td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaMultaVehiculos;
